exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit{display:flex;align-items:center;gap:8px;text-decoration:none!important;font-weight:600}.modal-change-custom-mirror{margin:20px 0}.modal-change-custom-mirror p{margin-left:15px;font-size:16px;font-weight:600}.modal-change-custom-mirror p span{font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1bf00e04","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/companyDetail/listCustomMirrorPoint.vue
// module id = 1411
// module chunks = 0